export default __webpack_public_path__ + "assets/models/56ac99f35c141f532f8f01d6a3e3f45f.glb";